import React from "react";
import { ShoppingCart, ArrowLeftRight, Gift, Award, Shield, Sparkles, User } from "lucide-react";

export const PriceDisplay = ({ price, isDonation, className = "" }) => (
  <span className={className}>{isDonation ? 'FREE' : `£${Number(price || 0).toFixed(2)}`}</span>
);

export const StatusBadge = ({ status }) => {
  const colors = {
    active: 'bg-green-100 text-green-800', completed: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800', declined: 'bg-red-100 text-red-800',
    accepted: 'bg-blue-100 text-blue-800', default: 'bg-gray-200'
  };
  return <span className={`brutalist-badge text-[10px] py-0.5 px-2 ${colors[status] || colors.default}`}>{status}</span>;
};

const TRANSACTION_CONFIG = {
  sell: { bg: 'bg-blue-500', icon: <ShoppingCart className="w-3 h-3" />, label: 'Buy' },
  swap: { bg: 'bg-purple-500', icon: <ArrowLeftRight className="w-3 h-3" />, label: 'Swap' },
  donate: { bg: 'bg-green-500', icon: <Gift className="w-3 h-3" />, label: 'Free' }
};

export const TransactionTypeBadge = ({ type }) => {
  const c = TRANSACTION_CONFIG[type] || TRANSACTION_CONFIG.sell;
  return <span className={`${c.bg} text-white text-xs px-2 py-1 rounded-full flex items-center gap-1 font-bold`}>{c.icon}{c.label}</span>;
};

export const AgeBadge = ({ ageGroup }) => (
  <span className="bg-[#FFD93D] text-gray-900 text-xs px-2 py-1 rounded-full font-bold border border-gray-900">
    {ageGroup}
  </span>
);

export const KidTip = ({ children }) => (
  <div className="bg-[#E0F2FE] border-2 border-[#0EA5E9] rounded-xl p-4 flex items-start gap-3 my-4" data-testid="kid-tip">
    <div className="w-10 h-10 bg-[#0EA5E9] rounded-full flex items-center justify-center flex-shrink-0">
      <Sparkles className="w-5 h-5 text-white" />
    </div>
    <div>
      <p className="font-bold text-[#0369A1] text-sm mb-1">Helpful Tip!</p>
      <p className="text-gray-700 text-sm">{children}</p>
    </div>
  </div>
);

const TIER_COLORS = {
  basic:    { bg: "bg-gray-200",   text: "text-gray-900", border: "border-gray-900" },
  pro:      { bg: "bg-[#FF6B6B]",  text: "text-white",    border: "border-gray-900" },
  business: { bg: "bg-[#FFD93D]",  text: "text-gray-900", border: "border-gray-900" }
};

const TIER_LABELS = { pro: "Pro Seller", business: "Business", basic: "Basic" };

export const TierBadge = ({ tier }) => {
  const style = TIER_COLORS[tier] || TIER_COLORS.basic;
  const label = TIER_LABELS[tier] || TIER_LABELS.basic;
  return (
    <span
      data-testid={`tier-badge-${tier}`}
      className={`${style.bg} ${style.text} text-[10px] px-2 py-0.5 rounded-full font-bold border ${style.border} uppercase`}
    >
      {label}
    </span>
  );
};

export const TRUST_TIER_STYLES = {
  Elite:         { bg: "bg-[#FFD93D]",  text: "text-gray-900", icon: <Award className="w-3 h-3" /> },
  Trusted:       { bg: "bg-blue-500",   text: "text-white",    icon: <Shield className="w-3 h-3" /> },
  Rising:        { bg: "bg-purple-500", text: "text-white",    icon: <Sparkles className="w-3 h-3" /> },
  Newcomer:      { bg: "bg-green-500",  text: "text-white",    icon: <Sparkles className="w-3 h-3" /> },
  "New Member":  { bg: "bg-gray-300",   text: "text-gray-700", icon: <User className="w-3 h-3" /> }
};

const LOYALTY_STYLES = {
  diamond: { bg: "bg-gradient-to-br from-[#60A5FA] to-[#A78BFA]", text: "text-white", label: "DIAMOND SELLER" },
  gold:    { bg: "bg-gradient-to-br from-[#FFD93D] to-[#F59E0B]", text: "text-gray-900", label: "GOLD SELLER" },
};

export const LoyaltyBadge = ({ tier }) => {
  if (!tier) return null;
  const style = LOYALTY_STYLES[tier];
  if (!style) return null;
  return (
    <span
      data-testid={`loyalty-badge-${tier}`}
      className={`${style.bg} ${style.text} text-[10px] px-2 py-0.5 rounded-full font-black border-2 border-gray-900 inline-flex items-center gap-1`}
    >
      <Award className="w-3 h-3" />
      {style.label}
    </span>
  );
};
